import { fetchContent, MultipleItemResponse, SingleItemResponse } from './fetchContent'

type Args = {
  language: string
  urlSlug: string
  type: string
  preview?: boolean
}

export const getPageByTypeAndUrlSlug = async <Model>({
  language,
  urlSlug,
  preview,
  type
}: Args): Promise<SingleItemResponse<Model>> => {
  const response: MultipleItemResponse<any> = await fetchContent({
    path: '',
    preview,
    params: { language, limit: 1, 'elements.url_slug': urlSlug, 'system.type[in]': [type] }
  })

  if (response.pagination.count === 0) {
    throw new Error(`Cannot find page with url slug ${urlSlug}`)
  }

  return {
    item: response.items[0],
    modular_content: response.modular_content
  }
}
